import { Helmet } from '@dr.pogodin/react-helmet';

export const EmptyLayout = () => {
    return (
        <div className="mosey-layout">
            <Helmet>
                <title>Norges domstoler</title>
            </Helmet>
        </div>
    );
};

export default EmptyLayout;
